import { ReactNode } from 'react';

export interface SectionHeaderProps {
  className?: string;
  children?: ReactNode;
  sideContent?: ReactNode;
  belowContent?: ReactNode;
}

const SectionHeader = ({
  belowContent,
  children,
  className,
  sideContent,
}: SectionHeaderProps) => {
  return (
    <header
      className={['bg-white shadow-iots', className].filter(Boolean).join(' ')}
    >
      <div
        className={
          'main-content py-4 grid items-center gap-4 grid-cols-[1fr] grid-rows-[auto_auto] md:grid-cols-[1fr_auto] md:grid-rows-[auto]'
        }
      >
        <div
          className={
            !sideContent ? 'row-span-2 md:col-span-2 md:row-span-1' : undefined
          }
        >
          {children}
        </div>
        {sideContent && <div>{sideContent}</div>}
      </div>
      {belowContent && (
        <div className="main-content border-t border-t-iots-grey-200 py-[10px]">
          {belowContent}
        </div>
      )}
    </header>
  );
};

export default SectionHeader;
